<div class="card-category-container">
  <div class="card-category">
    @if (isCanPick) {
      @if (loader) {
        <ngx-skeleton-loader [theme]="{ width: '182px', height: '36px' }" />
      } @else if (categories && categories.length) {
        <app-button btnType="stroked"
                    (onChangeClick)="onSelectCategory()">
          {{ (selectedCategory ? 'change_category' : 'select_category') | translate }}
        </app-button>
      }
    }

    @if (loader && (categoryControl && categoryControl.value)) {
      <div class="card-category-selected-container">
        <span class="card-category-selected-title">
          <ngx-skeleton-loader [theme]="{ width: '134px', height: '24px' }" />
        </span>
        <div class="card-category-selected">
          <span class="card-category-selected-primary">
            <ngx-skeleton-loader [theme]="{ width: '70px', height: '18px' }" />
          </span>
          <span class="card-category-selected-secondary">
            <ngx-skeleton-loader [theme]="{ width: '36px', height: '18px' }" />
          </span>
        </div>
      </div>
    }
    @else if (selectedCategory) {
      <div class="card-category-selected-container">
        <span class="card-category-selected-title">{{ 'selected_category' | translate }}: </span>
        <div class="card-category-selected">
          <span class="card-category-selected-primary">
            {{ selectedCategory.name }}
          </span>
          <span class="card-category-selected-secondary">
            {{ selectedCategoryPathText }}
          </span>
        </div>
      </div>
    }

    @if (!loader && !(categories && categories.length)) {
      <mat-error>{{ 'notifications_texts.error.failed_to_retrieve_categories' | translate }}</mat-error>
    }
  </div>
  <mat-error class="card-category-error">
    @if (categoryControl && categoryControl.touched && categoryControl.invalid && categoryControl.errors && categoryControl.errors['required']) {
      {{ 'input_errors.empty_category' | translate }}
    }
  </mat-error>
</div>
